// removed by extract-text-webpack-plugin
module.exports = {"content":"_2ApfsY-GnTjJugYxO12xmz","title":"_3m9alEPfGJsw_EbxyEJ8EB","tooltipButtonWrapper":"NBEXk2y8q0FokbmHnfOFn","tooltipButton":"Suptvt8iVnkWgK0gC0a_M","phoneSection":"sLvjOnpfVRYHOtWgIQbG_","phoneInputWrapper":"_1XZf88SnH2tQGkXXseuKbc","verified":"_3JH5EuieXbM1KObEMdiq8D","submitButton":"ajGku1wuZqJoIsCKe_9DW","codeSection":"_-7epqepOdx5NZ_FuOFkPS","inputWrapper":"_1nDrO8fifxprxLPm4bhWnx","invalidMessage":"YsJX8HRyEG8S2uDsaA-7N","notReceiveMessage":"_2zyRlJV4TpCxd2R2LR6O5_","verificationForm":"_3nf_-xaPgDE82HYhfhnSnA","verifiedNumber":"rpwZ6mvy6u6fdq8bXTxnB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PhoneVerificationMyAccount/PhoneVerificationFormMyAccount.scss
// module id = 457
// module chunks = 0